.Icon {
  box-sizing: content-box;
  padding: 0;
}

.Icon > svg {
  display: block; /* Ensure SVG are unaffected by text styles and font metrics, maintaining vertical alignment */
}

.Icon--size-20 {
  width: var(--base-size-20);
  height: var(--base-size-20);
}

.Icon--size-24 {
  width: var(--base-size-24);
  height: var(--base-size-24);
}

.Icon--size-28 {
  width: var(--base-size-28);
  height: var(--base-size-28);
}

.Icon--size-32 {
  width: var(--base-size-32);
  height: var(--base-size-32);
}

.Icon--size-36 {
  width: var(--base-size-36);
  height: var(--base-size-36);
}

.Icon--size-40 {
  width: var(--base-size-40);
  height: var(--base-size-40);
}

.Icon--size-44 {
  width: var(--base-size-44);
  height: var(--base-size-44);
}

.Icon--background {
  padding: var(--base-size-12);
  border-radius: var(--base-size-12);
}

.Icon--color-default {
  color: var(--brand-Icon-color-default);
}

.Icon--background-color-default {
  background-color: var(--brand-Icon-background-default);
}

.Icon--color-blue {
  color: var(--brand-Icon-color-blue);
}

.Icon--background-color-blue {
  background-color: var(--brand-Icon-background-blue);
}

.Icon--color-coral {
  color: var(--brand-Icon-color-coral);
}

.Icon--background-color-coral {
  background-color: var(--brand-Icon-background-coral);
}

.Icon--color-green {
  color: var(--brand-Icon-color-green);
}

.Icon--background-color-green {
  background-color: var(--brand-Icon-background-green);
}

.Icon--color-gray {
  color: var(--brand-Icon-color-gray);
}

.Icon--background-color-gray {
  background-color: var(--brand-Icon-background-gray);
}

.Icon--color-indigo {
  color: var(--brand-Icon-color-indigo);
}

.Icon--background-color-indigo {
  background-color: var(--brand-Icon-background-indigo);
}

.Icon--color-lemon {
  color: var(--brand-Icon-color-lemon);
}

.Icon--background-color-lemon {
  background-color: var(--brand-Icon-background-lemon);
}

.Icon--color-lime {
  color: var(--brand-Icon-color-lime);
}

.Icon--background-color-lime {
  background-color: var(--brand-Icon-background-lime);
}

.Icon--color-orange {
  color: var(--brand-Icon-color-orange);
}

.Icon--background-color-orange {
  background-color: var(--brand-Icon-background-orange);
}

.Icon--color-pink {
  color: var(--brand-Icon-color-pink);
}

.Icon--background-color-pink {
  background-color: var(--brand-Icon-background-pink);
}

.Icon--color-purple {
  color: var(--brand-Icon-color-purple);
}

.Icon--background-color-purple {
  background-color: var(--brand-Icon-background-purple);
}

.Icon--color-red {
  color: var(--brand-Icon-color-red);
}

.Icon--background-color-red {
  background-color: var(--brand-Icon-background-red);
}

.Icon--color-teal {
  color: var(--brand-Icon-color-teal);
}

.Icon--background-color-teal {
  background-color: var(--brand-Icon-background-teal);
}

.Icon--color-yellow {
  color: var(--brand-Icon-color-yellow);
}

.Icon--background-color-yellow {
  background-color: var(--brand-Icon-background-yellow);
}
